import { EventLocationResponse } from '../shared/types'
import { DropDownElement } from '../shared/components/DropDownComponent'

const getEventLocationDropdownOptions = (eventLocations: EventLocationResponse) => {
  const options: DropDownElement[] = []
  eventLocations.results.map(location => {
    location.id && options.push({
      key: location.id,
      value: location.name,
    })
  })
  return options
}

export default getEventLocationDropdownOptions
